import { render, staticRenderFns } from "./model-picker.vue?vue&type=template&id=cb611f6e&scoped=true&"
import script from "./model-picker.vue?vue&type=script&lang=js&"
export * from "./model-picker.vue?vue&type=script&lang=js&"
import style0 from "./model-picker.vue?vue&type=style&index=0&id=cb611f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb611f6e",
  null
  
)

export default component.exports